import { useCacheDataManager } from 'global/cnr/contexts/useHelpers/cacheDataManager';
import { mediaHelpers } from 'global/viewSettings/importing/mediaResults';
import _ from 'lodash';
import { useCallback, useContext, useState } from 'react';
import { sportsHelpers } from '../cnr/reducers/reducerHelpers/sportsHelpers';
import { filterHelpers } from 'global/common/filtering';
import { useSportsFilters } from './useSportsFilters';
import { convertHelpers } from 'global/common/convert';
import { _matchLsTypes } from '../cnr/reducers/SportsDataReducer';
import { useFetchMedia } from './useFetchMedia';
import { formatItem, formatTypes } from 'global/common/dateFormatting';
import { httpsCallable } from 'firebase/functions';
import { AppContext } from 'global/cnr/contexts/AppProvider';

const _saveToLf = false

export const useMedia = ({ database_fns, pathViews, links_score, teams, sportsModeSport, sportsKey, sportsAbr }) => {

  let _season = 'fall'

  const cdm = useCacheDataManager()

  const { getMedia_resultsOnly, getMedia_standingsOnly, data, loading, error } = useFetchMedia({
    concurrency: 4,
    delay: 750
  })

  switch (sportsModeSport) {
    case 'soccer':
    case 'football':
      _season = 'fall'
      break;
    case 'basketball':
      _season = 'winter'
      break;
    case 'baseball':
    case 'softball':
      _season = 'spring'
      break;
    default:
  }

  const [mediaSeason_local, setMediaSeason_local] = useState()
  const [mediaResults_local, setMediaResults_local] = useState()
  const [mediaAlignment_local, setMediaAlignment_local] = useState()
  const [mediaResults_direct, setMediaResults_direct] = useState()
  const [mediaAlignment_direct, setMediaAlignment_direct] = useState()

  const { getSectionDates } = useSportsFilters()

  const getDateGroupKeys = (year, season) => sportsHelpers.generateDatesByYear([year], season)

  const getMediaCdm = useCallback((year) => {
    getMedia_cdm(cdm, sportsKey, year, setMediaSeason_local, setMediaResults_local, setMediaAlignment_local, teams, getSectionDates, database_fns)
  }, []);

  const updateMedia_localResults = useCallback(({ sportsKey, year, mediaResults }) => {
    cdm.mergeToGroup('mediaResults', `${sportsKey}-${year}`, mediaResults)
  }, []);

  const updateMedia_localAlignment = useCallback(({ sportsKey, year, alignmentResults }) => {
    cdm.mergeToGroup('mediaAlignment', `${sportsKey}-${year}`, alignmentResults)
  }, []);

  const getMedia_records = useCallback(({ sportsYear, yearCount, callback }) => {
    mediaHelpers.getMedia_alignments(yearCount, links_score, sportsYear, sportsAbr, teams, callback)
  }, []);

  const getMedia_results = useCallback(async ({ sportsYear, yearAdditional, callback }) => {

    const dateGroupKeys = getDateGroupKeys(sportsYear, _season)

    const callData = {
      dateGroupKeys: dateGroupKeys[sportsYear + yearAdditional],
      links_score,
      year: sportsYear,
      _useSingleDate: true,
      sport: 'basketball',
      singleDate: '02/06/2026'
    }

    // console.log('callData', callData)
    // const getMediaScores = httpsCallable(mainFunctions, 'getMediaScores');
    // const response = await getMediaScores(callData)
    // console.log('response', response)
    // callback(response)

    const mergedMatches = await getMedia_resultsOnly(callData, true)
    // console.log('mergedMatches', mergedMatches)
    // if (_saveToLf) {
    //   cdm.mergeToGroup('mediaResults', `${sportsKey}-${sportsYear}`, mergedMatches)
    //   const mediaTeams = buildTeamsFromMatches(mergedMatches, teams)
    //   cdm.mergeToGroup('mediaTeams', `${sportsKey}-${sportsYear}`, mediaTeams)
    // }
    callback(mergedMatches)
    // mediaHelpers.getMedia_results({...callData}, cb)
  }, []);


  const getMedia_alignments = useCallback(async ({ sportsYear, callback }) => {
    const callData = {
      links_score,
      year: sportsYear,
      existingTeams: teams,
      database_fns
      // _useSingleDate: true,
      // singleDate: '02/06/2026'
    }
    const xxx = await getMedia_standingsOnly(callData)
    console.log('xxx', xxx)
    callback(xxx)
    // mediaHelpers.getMedia_alignment(links_score, sportsYear, sportsAbr, teams, callback)
  }, []);

  const ammendMedia_season = useCallback(({ matches, results_alignment, sportsYear, callback }) => {
    const { teams: teams_media, sectionCounts, alignments } = results_alignment ?? {}
    const mediaSeason = { teams: teams_media, alignments: alignments }
    const _mediaSeason = mediaHelpers.ammendMedia_season(
      database_fns,
      matches,
      teams,
      pathViews,
      sportsYear,
      sportsAbr,
      false,
      false,
      alignments,
      sectionCounts,
      mediaSeason
    )
    callback(_mediaSeason)
  }, []);

  const getMedia_alignmentsAndResults = useCallback(({ sportsYear, callback }) => {
    const cb_results = (matches) => {
      const cb_alignments = (results_alignment) => {
        const { teams: teams_media, sectionCounts, alignments } = results_alignment
        const mediaSeason = { teams: teams_media, alignments: alignments }
        const _mediaSeason = mediaHelpers.ammendMedia_season(database_fns, matches, teams, pathViews, year, sportsYear, false, false, alignments, sectionCounts, mediaSeason)
        callback(mediaSeason, matches)
      }
      mediaHelpers.getMedia_alignment(links_score, sportsYear + 1, sportsAbr, teams, cb_alignments)
    }
    const dateGroupKeys = getDateGroupKeys(sportsYear, _season)
    mediaHelpers.getMedia_results(dateGroupKeys[sportsYear], false, links_score, sportsYear, sportsAbr, teams, false, cb_results)
  }, []);

  return {
    ammendMedia_season,
    getMedia_alignments,
    getMedia_alignmentsAndResults,
    getMediaCdm,
    getMedia_records,
    getMedia_results,
    mediaSeason_local,
    mediaAlignment_local,
    mediaResults_local,
    updateMedia_localResults,
    updateMedia_localAlignment,
  }

}

const toSectionKey = (str) => {
  return str
    .replace(/\s*\(.*/, '')      // remove anything starting with '('
    .replace(/\s+(\w)/g, (_, c) => c.toUpperCase()) // camelCase
    .replace(/^./, c => c.toLowerCase())
}


const getMedia_cdm = async (cdm, sportsKey, year, callback_mediaSeason, callback_results, callback_alignments, teamsx, getSectionDates, database_fns) => {

  const mediaResults = await cdm.getSubItem('mediaResults', `${sportsKey}-${year}`)
  const mediaAlignment = await cdm.getSubItem('mediaAlignment', `${sportsKey}-${year}`)
  const mediaTeams = await cdm.getSubItem('mediaTeams', `${sportsKey}-${year}`)

  console.log('mediaResults', mediaResults)

  if (!mediaResults) return;

  // L7OB3ByFTWLfUbizMNqG
  // fOHkoFZH5LGqIh5CDKRU
  const _teams = buildTeamsFromMatches(mediaResults, teamsx)

  const _lsTeams = _.mapValues(
    _.groupBy(_teams, 'levels'),
    levelTeams => ({
      sections: _.mapValues(
        _.groupBy(levelTeams, 'sections'),
        sectionTeams => ({
          teams: sectionTeams
        })
      )
    })
  )

  _.forEach(_lsTeams, (lst) => {
    _.forEach(lst.sections, (st) => {
      _.forEach(st.teams, (t, index) => {
        t.position = index
      })
    })
  })

  const matchez = getMatchesFromResults(mediaResults, teamsx, database_fns)

  const _lsMatches = _.mapValues(
    _.groupBy(matchez, 'levels'),
    levelMatches => ({
      sections: _.mapValues(
        _.groupBy(levelMatches, 'sections'),
        sectionMatches => ({
          matches: sectionMatches
        })
      )
    })
  )

  const _tmz = {}
  _.forEach(_teams, (team, teamKey) => {
    const _tms = _.filter(matchez, m => m?.away?._itemKey === teamKey || m?.home?._itemKey === teamKey);
    const _tmsg = _.groupBy(_tms, '_matchCollectionKey')
    _tmz[teamKey] = {
      name: team.name,
      matches: _tms,
      matches_g: _tmsg,
    }
  })

  // const _csv_match = ['id', '_itemKey', 'startDate', 'section', 'level', 'away', 'awayScore', 'home', 'homeScore', 'extra', 'oldStartDate', 'postponed', 'cancelled', 'exhibition', 'remove', 'matchFlip']
  // console.log('_tmz', _tmz)
  // const zzz = convertHelpers.convertArrayToCSV(mediaResults, _csv_match)
  // convertHelpers.copyToClipboard(zzz)

  const aaa = _.groupBy(matchez, '_matchCollectionKey')
  console.log('aaa', aaa)

  const { earliest, latest } = filterHelpers.getEarliestAndLatestDates(matchez)

  const ssss = findInvalidHomeAwayMatchups(matchez)

  console.log('_lsTeams', _lsTeams)
  console.log('_lsMatches', _lsMatches)
  console.log('matchez', matchez)

  console.log('ssss', ssss)

  const mediaSeason = {
    teams_seasonal: {
      teams: _teams,
      lsTeams: _lsTeams,
    },
    matches_seasonal: {
      matches: matchez
    },
    seasonals: {
      details: {
        seasonStartDate: earliest,
        seasonEndDate: latest,
      },
      sectionCounts: getSectionCountsFromTeams(_teams),
      sectionDates: getSectionDates({ matches: matchez })
    }
  }

  const _mediaAlignment = mediaAlignment ? mediaAlignment?.data || mediaAlignment : {}
  const _mediaResults = mediaResults ? mediaResults?.data || mediaResults : {}

  delete _mediaAlignment._timestamp
  delete _mediaResults._timestamp

  callback_mediaSeason({ [year]: mediaSeason || {} });
  callback_results({ [year]: mediaResults || {} });
  callback_alignments({ [year]: mediaAlignment || {} });


}

const getMatchesFromResults = (mediaResults, teamsx, database_fns) => {

  const matchez = {}

  _.forEach(mediaResults, (mr) => {
    const { away, home, homeScore, awayScore, startDate } = mr

    const matchKey = database_fns.get_docKey()

    // get the existing home and away teams
    const ets = {
      _home: _.find(teamsx, { name: home }),
      _away: _.find(teamsx, { name: away })
    }

    const _match = {
      home: ets._home ? _.pick(ets._home, ['name', 'id', 'levels', 'sections', '_itemKey']) : { name: home },
      away: ets._away ? _.pick(ets._away, ['name', 'id', 'levels', 'sections', '_itemKey']) : { name: away },
      startDate: formatItem(formatTypes.shortestDate, startDate),
      startTime: '7:00 PM',
      ...getLnS(ets, mr),
      _itemKey: matchKey
    }

    if (homeScore && awayScore) {
      _match.results = {
        score: {
          home: homeScore,
          away: awayScore,
        }
      }
    }

    if (ets._home?._itemKey && ets._away?._itemKey) {
      _match.teams = [ets._home._itemKey, ets._away._itemKey]
    } else if (ets._home?._itemKey) {
      _match.teams = [ets._home._itemKey]
    } else if (ets._away?._itemKey) {
      _match.teams = [ets._away._itemKey]
    }

    matchez[matchKey] = _match

  })

  return matchez

}

const getSectionCountsFromTeams = (teams) => {
  // Group by level and count unique sections starting with 'section' for each level
  return _(teams)
    .groupBy('levels')
    .mapValues(levelTeams =>
      _(levelTeams)
        // .filter(team => team.sections.startsWith('section')) // Include only sections that start with 'section'
        .uniqBy('sections')
        .size()
    )
    .value();
};

/**
 * creates a new object for each team
 * 
 * @param {*} matches 
 * @param {*} teamsx 
 * @returns 
 */
const buildTeamsFromMatches = (matches = [], teamsx) => {

  const teams = {}

  _.forEach(matches, match => {
    const {
      home,
      away,
      levels,
      sections,
      _header,
    } = match

    const resolvedSection = sections === 'tbd' &&
      levels !== 'tbd' &&
      levels !== 'tournament' &&
      _header.section.toLowerCase().startsWith('section') &&
      _header?.level?.includes(levels)
      ? toCamelCase(_header.section)
      : null;

    if (resolvedSection) {
      [home, away].forEach(teamName => {
        const _team = _.find(teamsx, { name: teamName })
        if (!teams[teamName] && _team) {
          teams[teamName] = {
            name: teamName,
            levels,
            sections: resolvedSection,
          }
          return
        }

        if (teams[teamName]) {
          // Fill section only if still TBD
          if (
            teams[teamName].sections === 'tbd' &&
            resolvedSection !== 'tbd'
          ) {
            teams[teamName].sections = resolvedSection
          }
        }
      })
    }
  })

  const teamObjs = _.values(teams)

  const teamz = {}
  _.forEach(teamObjs, team => {
    const _team = _.find(teamsx, { name: team.name })
    teamz[_team._itemKey] = {
      ...team,
      _itemKey: _team._itemKey
    }
  })

  return teamz
}

const getLnS = (ets, flatMatch) => {

  const { _home, _away } = ets

  const { _lsp } = flatMatch ?? {}
  const { level, exlude } = _lsp ?? {}
  if (exlude) {
    console.log('excluded', flatMatch)
  }
  switch (level) {
    case _matchLsTypes.tournament:
      return { sections: _matchLsTypes.tournament, levels: _matchLsTypes.tournament, _matchCollectionKey: _matchLsTypes.tournament }
    default:
      if (!_home || !_away) {
        return { sections: _matchLsTypes.Non, levels: _matchLsTypes.nonLevel, _matchCollectionKey: _matchLsTypes.nonDistrict }
      } else {
        if (_home?.levels === _away?.levels && _home?.sections === _away?.sections) {// same level, same section 
          return { sections: toSectionKey(_home.sections), levels: _home.levels, _matchCollectionKey: _home.levels }
        } else if (_home?.levels === _away?.levels && _home?.sections !== _away?.sections) { // same level, different section
          return { sections: _matchLsTypes.Non, levels: _home.levels, _matchCollectionKey: _matchLsTypes.Non }
        } else if (_home?.levels && _home?.sections && _away?.levels && _away?.sections) {// different level, different section
          return { sections: _matchLsTypes.Non, levels: _matchLsTypes.Non, _matchCollectionKey: _matchLsTypes.Non }
        } else if (!_home || !_away) {
          return { sections: _matchLsTypes.Non, levels: _matchLsTypes.Non, _matchCollectionKey: _matchLsTypes.nonDistrict }
        }
      }
  }
  // sections: toSectionKey(sectionGroupKey), 
}

const toCamelCase = (str = '') =>
  str
    .toLowerCase()
    .replace(/\(.*?\)/g, '')
    .trim()
    .replace(/[^a-z0-9]+(.)/g, (_, chr) => chr.toUpperCase())

const findInvalidHomeAwayMatchups = (matches) => {

  const _allMatchCollections = _.groupBy(matches, '_matchCollectionKey')
  const levelMatches = _.omit(_allMatchCollections, [
    'nonDistrict',
    'nonLevel',
    'nonSection',
    'tournament'
  ])

  const pairTracker = {};
  const violations = [];

  Object.entries(levelMatches).forEach(([matchKey, match]) => {
    const home = match?.home?.name;
    const away = match?.away?.name;

    if (!home || !away) return;

    const pairKey = [home, away].sort().join('__'); // unordered
    const venueKey = `${home}__${away}`;            // ordered (venue)

    if (!pairTracker[pairKey]) {
      pairTracker[pairKey] = {
        venues: {},        // venueKey -> { matchKey, match }
        matches: []        // [{ matchKey, match }]
      };
    }

    const pair = pairTracker[pairKey];

    // ❌ same home/away already exists
    if (pair.venues[venueKey]) {
      violations.push({
        type: 'DUPLICATE_VENUE',
        pair: pairKey,
        home,
        away,
        matches: [
          pair.venues[venueKey], // original
          { matchKey, match }    // duplicate
        ]
      });
    }

    pair.matches.push({ matchKey, match });

    // ❌ more than home + away total
    if (pair.matches.length > 2) {
      violations.push({
        type: 'TOO_MANY_MATCHES',
        pair: pairKey,
        matches: [...pair.matches] // full objects
      });
    }

    pair.venues[venueKey] = { matchKey, match };
  });

  return violations;
};

